export class Contact {
    name = "";
    id = "";
    email = "";
}